import { DocumentsResponse } from "@/types/Documents";
import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

export const documentApi = createApi({
  reducerPath: "documentApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  tagTypes: ["document"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getUploadDocument: builder.query({
      query: (id) => `/document/${id}`,
      providesTags: ["document"],
    }),

    deleteDocument: builder.mutation<DocumentsResponse, number>({
      query: (id) => ({
        url: `/document/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["document"],
    }),

    getrecentDocumentStatus: builder.query<
      any[],
      { company_id?: any; offset?: number; limit?: number }
    >({
      query: ({ company_id, offset = 0, limit = 10 }) =>
        `/document/recent-document?company_id=${company_id}&offset=${offset}&limit=${limit}`,
      providesTags: ["document"],
    }),
    // getDocumentStatus: builder.query({
    //   query: (documentId) => ({
    //     url: `/document-status/${documentId}`,
    //     method: "GET",
    //   }),
    // }),
  }),
});

export const {
  useGetUploadDocumentQuery,
  useDeleteDocumentMutation,
  useGetrecentDocumentStatusQuery,
  // useGetDocumentStatusQuery
} = documentApi;
